import React from 'react'
import {Box} from '../../webui/Box'
import {Button} from '../../webui/Button'
import {TextField} from '../../webui/inputs/TextField'

interface Props {
  label: string
  onSearchChange: (search: string) => void
}

export const SearchFilter: React.FC<Props> = ({label, onSearchChange}) => {
  const [term, setTerm] = React.useState('')

  const trigger = () => onSearchChange(term)

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') trigger()
  }

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <TextField label={label} value={term} onChange={setTerm} onKeyDown={onKeyDown} />
      <Button onClick={trigger}>Search</Button>
    </Box>
  )
}
